import React, { Fragment, useState, useEffect } from "react";
import $ from "jquery"
import MetaTags from "react-meta-tags";
import Header from "../layouts/Headerthree";
import Breadcrumbs from "../layouts/Breadcrumb";
import Footer from "../layouts/Footer";
import Content from "../sections/privacy/Content";
import Loader from "../layouts/Preloader";
// import { useParams } from "react-router-dom";

const pagelocation = "Privacy Policy";

const Privacy = () => {

  const [appState, setAppState] = useState({
    repos: null,
  });

  // let { slugname } = useParams();

  useEffect(() => {
    const slugname = process.env.REACT_APP_SITE_URL || window.location.hostname;
    const apiCall = `${process.env.REACT_APP_API_URL}/website-manager/site/${slugname}`
    setAppState({ loading: true });
    const apiUrl = apiCall;
    fetch(apiUrl)
      .then((res) => res.json())
      .then((repos) => {
        setAppState({ repos: repos });
      });
  }, [setAppState]);

  const storeInfo = appState?.repos?.business;
  const business_name = storeInfo?.name;
  const storeLocation = storeInfo?.location?.address
  const storePhone = storeInfo?.location?.contact?.phone_number
  const bannerInfo = storeInfo?.website_manager?.banner_section
  const social_media_url = storeInfo?.website_manager?.social_media;
  const contact_details = appState?.repos?.location_list
  const business_logo_url = storeInfo?.website_manager?.logo
  const bgimage_url = storeInfo?.website_manager?.banner_section?.banner_image_url;
  const page_title = storeInfo?.website_manager?.seo?.title || business_name
  const page_keywords = storeInfo?.website_manager?.seo?.keywords
  const page_description = storeInfo?.website_manager?.seo?.description
  const websiteUrlValue=storeInfo?.website_manager?.website_url
  const custom_script_code = storeInfo?.website_manager?.analytics?.custom_script
  const custom_body_script_code = storeInfo?.website_manager?.analytics?.custom_body_script
  const custom_page = storeInfo?.website_manager?.custom_page
  const new_custom_page = storeInfo?.website_manager?.new_custom_page
  const isWebsiteWidget = appState?.repos?.website_widget_status
  const isCateringMenu = appState?.repos?.website_catering_menu_count
  const isSpecialMenu = appState?.repos?.website_special_menu_count
  const website_background_color = storeInfo?.website_manager?.website_background_color
  const website_text_color = storeInfo?.website_manager?.website_text_color;
  const website_footer_color = storeInfo?.website_manager?.website_header_footer_color
  const theme_color = storeInfo?.website_manager?.website_theme_color
  const bannerButtonColor = storeInfo?.website_manager?.banner_section?.call_to_action_button_background_color
  const headerMenuColor = storeInfo?.website_manager?.header_text_color || '#ffffff'
  const headerMenuActiveColor = storeInfo?.website_manager?.header_hover_text_color || theme_color
  const footerHeaderColor = storeInfo?.website_manager?.footer_heading_color || '#ffffff'
  const footerTextColor = storeInfo?.website_manager?.footer_text_color || '#b7b7b7'
  const pageTitleColor = storeInfo?.website_manager?.page_title_color || '#ffffff'
  const pageTitleBackgroundColor = storeInfo?.website_manager?.page_title_background_color || '#000000'
  const notifyBackgroundColor = storeInfo?.website_manager?.notification_background_color || '#55433e'
  const notifyTextColor = storeInfo?.website_manager?.notification_text_color || '#C6812A'
  const notifyHoverColor = storeInfo?.website_manager?.notification_hover_color || '#515151'
  let isShowExtraPage = false
  if (storeInfo?._id.toString() === '--') isShowExtraPage = true

  useEffect(() => {
    document.querySelector(':root').style.setProperty('--themeColor', theme_color)
    document.querySelector(':root').style.setProperty('--textColor', website_text_color)
    document.querySelector(':root').style.setProperty('--bannerButtonColor', bannerButtonColor)
    document.querySelector(':root').style.setProperty('--menuColor', headerMenuColor)
    document.querySelector(':root').style.setProperty('--menuActiveColor', headerMenuActiveColor)
    document.querySelector(':root').style.setProperty('--footerTitle', footerHeaderColor)
    document.querySelector(':root').style.setProperty('--footerText', footerTextColor)
    document.querySelector(':root').style.setProperty('--HeaderColor', website_footer_color)
    document.querySelector(':root').style.setProperty('--notifyBackgroundColor', notifyBackgroundColor)
    document.querySelector(':root').style.setProperty('--notifyTextColor', notifyTextColor)
    document.querySelector(':root').style.setProperty('--notifyHoverColor', notifyHoverColor)
    document.querySelector(':root').style.setProperty('--backgroundColor', website_background_color)
  }, [
    theme_color,
    bannerButtonColor,
    headerMenuColor,
    headerMenuActiveColor,
    footerHeaderColor,
    footerTextColor,
    website_footer_color,
    website_text_color,
    notifyBackgroundColor,
    notifyTextColor,
    notifyHoverColor,
    website_background_color,
  ]);

  const privacyPageSubBannerTempUrl = `${window.location.origin}/assets/default/banner-default.jpg`
  const businessId = storeInfo?._id
  const hideHeaderBackground = storeInfo?.website_manager?.hide_header_background
  const new_custom_page_2 = storeInfo?.website_manager?.new_custom_page_2
  const new_custom_page_3 = storeInfo?.website_manager?.new_custom_page_3
  const contactSection = storeInfo?.website_manager?.contact_section
  const show_jobs_page = storeInfo?.website_manager?.jobs_page?.show_jobs_page
  const show_gallery_page = storeInfo?.website_manager?.show_gallery_page
  const hidePageHeading = storeInfo?.website_manager?.hide_overlay_page_heading
  const faqs_jobs_page = storeInfo?.website_manager?.faqs?.show_faq_page

  useEffect(() => {
    if (custom_script_code) {
      $("head").append(custom_script_code);
    }
    if (custom_body_script_code) {
      $("body").append(custom_body_script_code);
    }
  }, [custom_script_code, custom_body_script_code]);

  if (!business_name) return <Loader />;

  return (
    <Fragment>
      <MetaTags>
        <title>
          {page_title} - {pagelocation}
        </title>
        <meta name="description" content={page_description} />
        <meta name="keywords" content={page_keywords} />
      </MetaTags>
      <Header
        logo={business_logo_url}
        businessName={business_name}
        contactInfo={contact_details}
        customPage={custom_page}
        newCustomPage={new_custom_page}
        isCateringMenu={isCateringMenu}
        isSpecialMenu={isSpecialMenu}
        isShowExtraPage={isShowExtraPage}
        websiteFooterColor={website_footer_color}
        hideHeaderBackground={hideHeaderBackground}
        storeLocation={storeLocation}
        storePhone={storePhone}
        bannerInfo={bannerInfo}
        newCustomPage2={new_custom_page_2}
        newCustomPage3={new_custom_page_3}
        websiteBackgroundColor={website_background_color}
        websiteTextColor={website_text_color}
        socialMedia={social_media_url}
        jobsPageShow={show_jobs_page}
        contactSection={contactSection}
        businessId={businessId}
        showGalleryPage={show_gallery_page}
        faqsPageShow={faqs_jobs_page}
      />
      <Breadcrumbs
        breadcrumb={{ pagename: pagelocation }}
        bgimage={bgimage_url || privacyPageSubBannerTempUrl}
        pageTitleColor={pageTitleColor}
        pageTitleBackgroundColor={pageTitleBackgroundColor}
        businessName={business_name}
        websiteBackgroundColor={website_background_color}
        hidePageHeading={hidePageHeading}
      />
      <Content businessName={business_name} websiteUrlVal={websiteUrlValue} websiteBackgroundColor={website_background_color} />
      <Footer
        footer={{
          style: "ct-footer footer-dark",
        }}
        socialMedia={social_media_url}
        businessName={business_name}
        contactInfo={contact_details}
        logo={business_logo_url}
        businessCode={businessId}
        isWebsiteWidget={isWebsiteWidget}
        websiteFooterColor={website_footer_color}
        contactSection={contactSection}
        websiteBackgroundColor={website_background_color}
        jobsPageShow={show_jobs_page}
        bannerInfo={bannerInfo}
        websiteTextColor={website_text_color}
        faqsPageShow={faqs_jobs_page}
      />
    </Fragment>
  );
};

export default Privacy;
